import React, { useEffect, useState } from 'react';
import { Check, ChevronDown, Globe, X } from 'lucide-react';
import { languageOptions, useTranslation } from '../i18n/LocaleContext';

// 语言选择：与应用内其他弹窗一致的底部弹层，不再用悬浮小菜单
const LanguageSelector = ({ className = '' }) => {
  const { language, setLanguage, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [animating, setAnimating] = useState(false);

  const current = languageOptions.find((o) => o.code === language) || languageOptions[1];

  useEffect(() => {
    if (open) {
      setVisible(true);
      setTimeout(() => setAnimating(true), 10);
    } else {
      setAnimating(false);
      setTimeout(() => setVisible(false), 300);
    }
  }, [open]);

  const pick = (code) => {
    setLanguage(code);
    setOpen(false);
  };

  return (
    <>
      <div className={`relative ${className}`}>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-label={t('changeLanguage')}
          className="flex items-center gap-1.5 h-8 px-2.5 rounded-full text-[13px] font-medium
            transition-colors active:bg-black/[0.06]"
        >
          <Globe className="w-4 h-4 shrink-0" strokeWidth={1.9} />
          <span>{t(current.key)}</span>
          <ChevronDown
            className={`w-3.5 h-3.5 shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
            strokeWidth={2.2}
          />
        </button>
      </div>

      {visible && (
        <div className="fixed inset-0 z-[60]">
          <div
            className={`absolute inset-0 bg-black transition-opacity duration-300 ${animating ? 'opacity-50' : 'opacity-0'}`}
            onClick={() => setOpen(false)}
          />
          <div
            className={`absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-lift transform transition-transform duration-300 ease-out ${
              animating ? 'translate-y-0' : 'translate-y-full'
            }`}
          >
            <div className="flex items-center justify-between px-5 pt-4 pb-2">
              <h2 className="text-[16px] font-bold text-ink">{t('changeLanguage')}</h2>
              <button
                onClick={() => setOpen(false)}
                className="p-2 -mr-2 rounded-full text-ink-muted hover:bg-canvas transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            <div className="px-4 pb-6 pt-1">
              {languageOptions.map(({ code, key }) => {
                const active = code === language;
                return (
                  <button
                    key={code}
                    type="button"
                    role="option"
                    aria-selected={active}
                    onClick={() => pick(code)}
                    className={`w-full flex items-center gap-3 py-3.5 px-1 text-left transition-colors active:bg-canvas ${
                      active ? '' : 'border-b border-navy/[0.06] last:border-0'
                    }`}
                  >
                    <span className="flex-1 text-[14px] text-ink">
                      <span className={active ? 'font-bold' : 'font-medium'}>{t(key)}</span>
                    </span>
                    {active && <Check className="w-[18px] h-[18px] text-brand-500 shrink-0" strokeWidth={2.6} />}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LanguageSelector;
